import { getFunctions, httpsCallable } from 'firebase/functions';
import app from '../firebase';

const functions = getFunctions(app, 'europe-west1');
const sendPasswordReset = httpsCallable(functions, 'sendPasswordReset');

export const requestPasswordReset = async (email) => {
  const normalizedEmail = String(email || '').trim().toLowerCase();
  if (!normalizedEmail) {
    throw new Error('Enter the email address connected to your Fate Room account.');
  }

  try {
    await sendPasswordReset({ email: normalizedEmail });
  } catch (error) {
    const serviceError = new Error(
      error?.code === 'functions/resource-exhausted'
        ? 'Please wait a moment before requesting another password reset email.'
        : 'Fate Room could not send the reset email right now. Please try again shortly.',
    );
    serviceError.code = error?.code;
    throw serviceError;
  }
};
